<template>
  <div class="left-menu-box">
    <div class="menu-button" @click="(menu_flg == true) ? menu_flg = false : menu_flg = true">Ξ</div>
    <div class="main-box" :class="(menu_flg === true) ? 'small-menu' : ''">
      <h1 @click="home"><p alt="Stay Assist"></p>For Host</h1>
      <div class="menu-box">
        <input type="button" class="new-add" @click="lodging_add" value="＋ 新規宿泊登録" />
        <h2 class="main-box-h2">ステータス</h2>
        <ul>
          <li>
            <a :class="current_menu(value.status)" v-for="(value, index) in menus" :key="index" @click="menu_chg(value)">
              <label>{{value.name}}<span v-if="value.status == 1 || value.status == 2"> [{{list_num(value.status)}}]</span></label>
            </a>
          </li>
        </ul>
        <h2 class="main-box-h2">管理</h2>
        <ul>
          <li>
            <a :class="current_menu(value.status)" v-for="(value, index) in menus3" :key="index" @click="menu_chg(value)">
              <label>{{value.name}}</label>
            </a>
          </li>
        </ul>
        <h2 class="main-box-h2" @click="basic_menu_flg=!basic_menu_flg">
          基本情報
          <span v-if="basic_menu_flg">ー</span>
          <span v-else>＋</span>
        </h2>
        <ul v-if="basic_menu_flg">
          <li>
            <a :class="current_menu(value.status)" v-for="(value, index) in menus2" :key="index" @click="menu_chg(value)">
              <label>{{value.name}}</label>
            </a>
          </li>
        </ul>
        <input type="button" class="sidebar-logout" @click="logout" value="サインアウト" />
        <div class="menu-button2" @click="(menu_flg == true) ? menu_flg = false : menu_flg = true">✖︎</div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'LeftMenu',
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.$store.commit('loginInfo/set_lang', 'ja');
  },
  // ===========================================================================
  // props
  // ===========================================================================
  props: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      menus: [
        {name: '名簿未登録', address: 'unregistered', status: 1},
        {name: '名簿未承認', address: 'unaccepted', status: 2},
        {name: '名簿承認済', address: 'accepted', status: 3},
        {name: 'キャンセル', address: 'canceled', status: 4},
      ],
      menus2: [
        {name: 'オーナー情報設定', address: 'owner', status: 13},
        {name: 'リスティング設定', address: 'listing_list', status: 11},
        {name: 'メール定型文設定', address: 'mail_list', status: 12},
        {name: 'パスワード変更', address: 'pass_reset', status: 14},
      ],
      menus3: [
        {name: '清掃状況', address: 'clean', status: 21},
      ],
      menu_flg: false,
      basic_menu_flg: false,
    };
  },
  computed: {
    status () {
      return this.$store.getters['loginInfo/menu_status'];
    }
  },
  methods: {
    menu_chg (data) {
      this.$store.commit('loginInfo/set_status', data.status);
      this.$router.push({name: data.address, params: {}});
      this.menu_flg = false;
    },
    current_menu (status) {
      return this.status === status ? 'current_menu' : false;
    },
    lodging_add () {
      this.$router.push({name: 'lodging_add', params: {}});
    },
    logout () {
      localStorage.removeItem('lcpe_token');
      if (process.env.NODE_ENV === 'production') {
        location.href = '/login?type=logout';
      } else {
        location.href = '/3012/login?type=logout';
      }
    },
    list_num (status) {
      if (status === 1) {
        return this.$store.getters['loginInfo/unregistered_num'];
      }
      return this.$store.getters['loginInfo/unaccepted_num'];
    },
    home () {
      this.$router.push({name: 'unregistered', params: {}});
    }
  },
};
</script>

<style lang="scss">
.left-menu-box {
  h1 {
    background: #fbfbfb;
    padding: 18px 0 8px 0;
    text-align: center;
    font-size: 1.1rem;
    color: #24273b;
    cursor: pointer;
    font-weight: normal;

    p {
      background-image: url('../../assets/logo.svg');
      height: 28px;
      width: 134px;
      margin: 0 auto;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
  h2 {
    position: relative;
    span {
      display: inline-block;
      height: 15px;
      width: 15px;
      border-radius: 3px;
      border: 1px solid #1d1b50;
      margin-left: 8px;
      background: #1d1b50;
      color: #fefefe;
      text-align: center;
      line-height: 1.2;
      position: absolute;
      top: 5px;
      font-size: 0.9rem;
    }
  }
  .menu-box {
    padding: 0px 0px 20px 10px;
  }
  .main-box {
    position: fixed;
    left: 0;
    top: 0;
    font-weight: bold;
    height: 100%;
    z-index: 10;
    overflow-y: auto;
    width: 210px;
    text-align: left;
    background: #fbfbfb;
    padding: 0 0 0 0;
  }
  .menu-button {
    width: 50px;
    height: 50px;
    position: fixed;
    right: 10px;
    top: 12px;
    background: #ccc;
    line-height: 3.3;
    font-weight: 800;
    color: #fefefe;
    cursor: pointer;
    display: none;
    z-index: 100;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
  .menu-button2 {
    width: 50px;
    height: 50px;
    margin: 30px auto 0 auto;
    background: #ccc;
    line-height: 3;
    font-weight: 800;
    text-align: center;
    color: #fefefe;
    cursor: pointer;
    display: none;
    z-index: 100;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
  .main-box-h2 {
    font-size: 18px;
    font-weight: bold;
    padding: 0px 0px 0px 0px;
    margin: 14px 0px 0px 24px;
    color: #1d1b50;
  }

  ul {
    margin-left: 8px;
    li {
      a {
        display: block;
        color: #7d7f88;
        padding: 7px 10px 5px 10px;
        text-decoration: none;
        transition: all 0.2s ease;
        font-size: 14px;

        cursor: pointer;
        label {
          padding: 0 0 0 8px;
          height: 24px;
          line-height: 26px;
          display: inline-block;
          cursor: pointer;
        }
        &:hover{
          color: #1d1b50;
        }
      }
      a.current_menu{
        color: #1d1b50;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }
    }
  }
  .new-add {
    color: #fbfbfb;
    display: block;
    text-align: center;
    padding: 8px;
    width: 150px;
    font-size: 16px;
    margin: 5px auto 0px auto;
    text-decoration: none;
    border-radius: 3px;
  }
  .new-add:hover {
    color: #fbfbfb;
  }
  .sidebar-logout {
    color: #fefefe;
    display: block;
    text-align: center;
    padding: 8px;
    width: 120px;
    font-size: 16px;
    margin: 20px auto 0px auto;
    text-decoration: none;
    border-radius: 3px;
  }
  .sidebar-logout:hover {
    color: #fbfbfb;
  }
}
@media (max-width: 767px) {
  .left-menu-box {
    .main-box {
      left: -300px;
      transition: all 0.3s ease;
    }
    .menu-button {
      display: block;
    }
    .menu-button2 {
      display: block;
    }
    .small-menu {
      left: 0px;
      transition: all 0.3s ease;
    }
  }
}
</style>
